import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { Deal } from '@/models/registry';
import { Button } from '../../ui/button';
import { DELIVERY_PREFERENCE_OPTIONS_MAP } from './deal-delivery-preference-selector';

export const DealDeliveryPreferenceBadge = ({
  value: delivery_preference,
  hideCopy = false,
  className,
  buttonRef,
  useAbbreviation = false,
  hideIcon = false,
}: {
  value: Deal['delivery_preference'];
  hideCopy?: boolean;
  className?: string;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  useAbbreviation?: boolean;
  hideIcon?: boolean;
}) => {
  return (
    <Button
      variant="ghost"
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {delivery_preference === null && (
        <>
          <PDKEmptyValueIcon className="h-3.5 w-3.5" />
          {!hideCopy && (
            <p className="rounded text-xs  text-gray-600">
              No Delivery Preference
            </p>
          )}
        </>
      )}
      {DELIVERY_PREFERENCE_OPTIONS_MAP.map((option) => {
        if (hideIcon) {
          return null;
        }

        if (option.value === delivery_preference) {
          return <div key={option.value}>{option.icon}</div>;
        }
      })}

      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {useAbbreviation
            ? DELIVERY_PREFERENCE_OPTIONS_MAP.find(
                (option) => option.value === delivery_preference,
              )?.abbreviation
            : DELIVERY_PREFERENCE_OPTIONS_MAP.find(
                (option) => option.value === delivery_preference,
              )?.label}
        </p>
      )}
    </Button>
  );
};

export default DealDeliveryPreferenceBadge;
